export default __webpack_public_path__ + "images/warning.v-3ccd887b537514fb5d203d24e2595f7f.svg";